export const LIST = 'cities/LIST';
export const SINGLE = 'cities/SINGLE';
